import { createContext } from 'react';

export const GoogleLoginContext = createContext({});